import { translate } from './booleanQuery';

interface FormatQueryData {
  obligatory: string;
  optional: string;
  banned: string;
}

const formatQuery = (fields: FormatQueryData): string =>
  translate(fields).query;

export const formatInfluencersQuery = (fields: FormatQueryData): string =>
  translate(fields).query.replace(/"/g, '""');

export default formatQuery;
